/**
 * spot — one room (a cafe, a bar).
 * cluster — a yard, food hall or row of stalls. One card for the whole place.
 */
export enum EstablishmentKindEnum {
    SPOT = 'spot',
    CLUSTER = 'cluster',
}

export const ESTABLISHMENT_KIND_ORDER: EstablishmentKindEnum[] = [
    EstablishmentKindEnum.SPOT,
    EstablishmentKindEnum.CLUSTER,
];
